<template>
  <div>
    <Balance />
    <List />
  </div>
</template>
<script setup>
import Balance from "@/components/crypto/okx/positions/Balance"
import List from "@/components/crypto/okx/positions/List"
</script>
